export const enum EnvironmentMode {
	Dev = "dev",
	Qc = "qc",
	Staging = "staging",
	Production = "production",
}

export function parseEnvironmentMode(value: string | null | undefined): EnvironmentMode | null {
	switch (value) {
		case EnvironmentMode.Dev:
		case EnvironmentMode.Qc:
		case EnvironmentMode.Staging:
		case EnvironmentMode.Production:
			return value;
		default:
			return null;
	}
}
